/**
 * Nice Shot subscriber early access: countdown, and the access-code unlock.
 *
 * This file does NOT decide anything. It writes the code the visitor supplied onto the cart
 * (`cart.attributes.ea`) and reloads. The SERVER then compares it in snippets/ns-ea-state.liquid and
 * decides whether to render the clubs at all. A locked visitor never receives the markup, so nothing
 * here can reveal a club, and deleting this file cannot open the gate.
 *
 * Two ways in, both landing in the same place:
 *   1. ?ea=CODE on any store URL (the link in the email). Unlocks silently, strips the param.
 *   2. The code typed into the form on the locked page.
 *
 * Verified on the live storefront 2026-07-10: POST /cart/update.js {attributes:{ea:"..."}} returns
 * 200, and Liquid reads cart.attributes.ea on every subsequent page render, across collection and
 * product templates.
 */
(function () {
  var CART_UPDATE = '/cart/update.js';

  function saveCode(code) {
    return fetch(CART_UPDATE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ea: code } }),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed: ' + res.status);
      return res.json();
    });
  }

  function saveSource(value) {
    return fetch(CART_UPDATE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ea_src: value } }),
    });
  }

  /* ---------- 0. the drop email's campaign UTM ----------
     Klaviyo stamps utm_campaign on every link. Capture it into its own cart attribute and let the
     SERVER decide whether it grants access (ns-ea-state.liquid compares it to settings.ea_unlock_utm).
     Written blind: we do not know here which campaigns unlock, and we must not tell the browser.
     It goes in a separate attribute from the typed code, so an unrelated campaign's UTM never makes
     the locked page say "that code did not work".                                                  */
  (function captureCampaign() {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (e) {
      return;
    }
    var campaign = url.searchParams.get('utm_campaign');
    if (!campaign) return;

    // Don't re-POST the same value on every page of a session.
    var KEY = 'ns_ea_src';
    try {
      if (sessionStorage.getItem(KEY) === campaign) return;
    } catch (e) {}

    saveSource(campaign)
      .then(function () {
        try { sessionStorage.setItem(KEY, campaign); } catch (e) {}
        // The page we are on was already rendered as locked. Ask the server for it again, once,
        // now that the cart carries the campaign.
        if (document.querySelector('[data-ns-ea-form], .ns-ea-lock')) window.location.reload();
      })
      .catch(function () {});
  })();

  /* ---------- 1. the emailed link: /collections/early-access?ea=CODE ---------- */
  (function unlockFromLink() {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (e) {
      return;
    }
    var code = url.searchParams.get('ea');
    if (!code) return;

    // Strip the code from the address bar before anything else, so it is not shoulder-surfed,
    // copied out of the URL bar, or sent to analytics as a page path.
    url.searchParams.delete('ea');
    var clean = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;

    saveCode(code)
      .then(function () {
        window.location.replace(clean);
      })
      .catch(function () {
        window.history.replaceState({}, '', clean);
      });
  })();

  /* ---------- 2. the code typed on the locked page ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ns-ea-form]');
    if (!form) return;
    event.preventDefault();

    var input = form.querySelector('input[name="ea_code"]');
    var button = form.querySelector('button[type="submit"]');
    var code = (input && input.value || '').trim();
    if (!code) return;

    if (button) {
      button.disabled = true;
      button.textContent = 'Checking…';
    }

    saveCode(code)
      .then(function () {
        // The server decides. If the code is wrong we come back to a locked page, which will say so.
        window.location.reload();
      })
      .catch(function () {
        var err = document.querySelector('[data-ns-ea-error]');
        if (err) err.hidden = false;
        if (button) {
          button.disabled = false;
          button.textContent = 'Unlock';
        }
      });
  });

  /* ---------- 3. the countdown ---------- */
  var nodes = document.querySelectorAll('[data-ns-ea-countdown]');
  if (!nodes.length) return;

  var pad = function (n) { return String(n).padStart(2, '0'); };

  function paint(node, ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var set = function (sel, val) {
      var el = node.querySelector(sel);
      if (el) el.textContent = val;
    };
    set('[data-d]', String(Math.floor(total / 86400)));
    set('[data-h]', pad(Math.floor((total % 86400) / 3600)));
    set('[data-m]', pad(Math.floor((total % 3600) / 60)));
    set('[data-s]', pad(total % 60));
  }

  nodes.forEach(function (node) {
    var release = Date.parse(node.getAttribute('data-release'));
    if (isNaN(release)) return;

    var reloaded = false;
    var tick = function () {
      var left = release - Date.now();
      paint(node, left);
      if (left <= 0 && !reloaded) {
        reloaded = true;
        window.location.reload();
      }
    };
    tick();
    setInterval(tick, 1000);
  });
})();
